// Vlastní lightbox galerie detailu produktu — handover design_handoff_galerie/
// (README.md je závazný; mock `Galerie produktu koncepty.dc.html`, sekce 1b + 1c;
// 1a a 1d jsou zamítnuté koncepty). Nahrazuje výchozí Shoptet colorbox NA GALERII —
// colorbox dál žije pro detail cookies (_colorbox.scss zůstává).
//
//   • desktop ≥ 1024: světlý split — stage s fotkou + nákupní panel 380 px
//     (eyebrow kategorie, název, cena + sleva, CTA „Do košíku", mřížka miniatur,
//     „Zpět na detail"). Zoom: klik 2,2× do místa kliknutí, pohyb myši panuje
//     výřez (transform-origin sleduje kurzor), kolečko doladí 1–4×.
//   • mobil < 1024: fullscreen pager na černé — pinch 1–4× (rubber-band pod 1×),
//     double-tap 2,5×, pan se setrvačností, swipe ← → (při zoomu až po dotažení
//     na okraj), swipe ↓ zavírá, minimapa od 2×, hint 1× za session, zoom badge,
//     chrome se skryje po 3 s nečinnosti. Android zpět zavírá (history state).
//
// Zdroj fotek: nativní `a.p-thumbnail` (href = `big/` varianta) — sbírá se při
// KAŽDÉM otevření, u variantních produktů default JS galerii přepisuje.
// Popisek fotky: `data-caption`/`alt`, ale jen když se liší od názvu produktu —
// Shoptet plní alt názvem produktu u všech fotek a pill by jen duplikoval panel.
// Košík: klik na CTA pouští NATIVNÍ `.add-to-cart-button` (vzor stickyAtc.js),
// pak se galerie zavře a nechá proběhnout nativní modal „Přidáno do košíku".
//
// Idempotentní (`html.bs-gal-ready`). Bez závislostí (vanilla, pointer events).

import { icon } from './icon.js';
import { createPriceWatch, discountPercent as pctOf, formatPrice, parseNumber } from './productPrice.js';
import L from '../locale/cs/galleryLightbox.js';

const LABEL_DIALOG = L.dialog;
const LABEL_CLOSE = L.close;
const LABEL_PREV = L.prev;
const LABEL_NEXT = L.next;
const LABEL_CART = L.cart;
const LABEL_ALL_PHOTOS = L.allPhotos;
const LABEL_BACK = L.back;
const LABEL_PHOTO = L.photo;
const LABEL_HINT = L.hint;

const BP_DESKTOP = 1024;
// Desktop zoom (README §Interakce): klik = 2,2×, kolečko dolaďuje 1–4×
export const ZOOM_CLICK = 2.2;
export const ZOOM_MAX = 4;
// Mobil (README §Gesta): double-tap 2,5×, minimapa od 2×
export const ZOOM_DBLTAP = 2.5;
const ZOOM_MINIMAP = 2;
const CHROME_HIDE_MS = 3000;
const MINIMAP_HIDE_MS = 1500;
const HINT_HIDE_MS = 2500;
const DBLTAP_MS = 300;
const SWIPE_COMMIT_PX = 50; // min. dráha švihu při pomalém tahu řeší poměr níž
const SWIPE_COMMIT_RATIO = 0.25;
const DISMISS_RATIO = 0.25;
const FLICK_V = 0.55; // px/ms — rychlé švihnutí přepne/zavře i pod prahem dráhy
const EDGE_SWITCH_PX = 60; // přetažení za okraj fotky při zoomu = další fotka
const HINT_KEY = 'bsGalHint';

function text(el) {
  return el ? (el.textContent || '').replace(/\s+/g, ' ').trim() : '';
}

function node(tag, className, content) {
  const el = document.createElement(tag);
  if (className) el.className = className;
  if (content != null) el.textContent = content;
  return el;
}

function button(className, label) {
  const el = node('button', className);
  el.type = 'button';
  if (label) el.setAttribute('aria-label', label);
  return el;
}

function reducedMotion() {
  return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
}

function clamp(v, min, max) {
  return Math.min(max, Math.max(min, v));
}

// „2,5 ×" — čárka, mezera před × (formát z mocku)
export function zoomLabel(z) {
  const r = Math.round(z * 10) / 10;
  return String(r % 1 === 0 ? r : r.toFixed(1)).replace('.', ',') + '\u00A0×';
}

// Popisek fotky: jen skutečný popisek, ne alt = název produktu (Shoptet default)
export function captionFor(caption, productName) {
  const c = (caption || '').replace(/\s+/g, ' ').trim();
  if (!c) return '';
  if (productName && c.toLowerCase() === productName.replace(/\s+/g, ' ').trim().toLowerCase()) return '';
  return c;
}

// Meze posunu výřezu: contain-fit fotka naturalW×H v boxu w×h při zoomu z.
// Vrací { x, y } = max |translate| na každé ose (0 = fotka se do boxu vejde).
export function panBounds(boxW, boxH, naturalW, naturalH, z) {
  if (!naturalW || !naturalH || !boxW || !boxH) return { x: 0, y: 0 };
  const fit = Math.min(boxW / naturalW, boxH / naturalH);
  const w = naturalW * fit * z;
  const h = naturalH * fit * z;
  return { x: Math.max(0, (w - boxW) / 2), y: Math.max(0, (h - boxH) / 2) };
}

// URL bez query — cache-busting `?ts=` se mezi uzly liší, jádro fotky ne
function hrefKey(href) {
  return String(href || '').split('?')[0];
}

function collectPhotos() {
  const out = [];
  const seen = {};
  document.querySelectorAll('.p-image-wrapper a.p-thumbnail').forEach(function (a) {
    const key = hrefKey(a.href);
    if (!key || seen[key]) return;
    seen[key] = true;
    const img = a.querySelector('img');
    out.push({
      big: a.href,
      thumb: img ? img.currentSrc || img.src : a.href,
      caption: a.getAttribute('data-caption') || (img ? img.getAttribute('alt') : '') || '',
    });
  });
  if (!out.length) {
    const main = document.querySelector('.p-image a.p-main-image');
    if (main) {
      const img = main.querySelector('img');
      out.push({ big: main.href, thumb: main.href, caption: main.getAttribute('data-alt') || (img ? img.alt : '') || '' });
    }
  }
  return out;
}

function productName() {
  return text(document.querySelector('.p-detail-inner-header h1')) || text(document.querySelector('.p-detail-inner-header-mobile .h1'));
}

// „−34 %" z nativního `.price-save` nebo dopočtem (vzor productDetail.js)
function discountPercent(form) {
  if (!form) return null;
  const m = text(form.querySelector('.price-save')).match(/(\d+)\s*%/);
  if (m) return parseInt(m[1], 10);
  const std = parseNumber(text(form.querySelector('.price-standard')));
  const now = parseNumber(text(form.querySelector('.price-final')));
  return pctOf(std, now); // dolů jako Shoptet
}

export function initGalleryLightbox() {
  const root = document.documentElement;
  if (root.classList.contains('bs-gal-ready')) return;
  if (!document.body.classList.contains('type-product')) return;
  if (!document.querySelector('.p-image-wrapper .p-image')) return;
  root.classList.add('bs-gal-ready');

  const mqDesktop = window.matchMedia('(min-width: ' + BP_DESKTOP + 'px)');
  const form = document.querySelector('#product-detail-form');
  let watch = null; // lazy — createPriceWatch věší observery, netvořit při každém otevření

  // stav otevřené galerie (null = zavřeno)
  let st = null;

  // ---------------------------------------------------------------------------
  // Otevření / zavření / přepínání fotek
  // ---------------------------------------------------------------------------

  function open(photos, index, opener) {
    if (st) return;
    st = {
      photos: photos,
      index: clamp(index, 0, photos.length - 1),
      opener: opener || null,
      desktop: mqDesktop.matches,
      z: 1,
      // mobilní zoom stav: translate(x, y) scale(z)
      mz: { z: 1, x: 0, y: 0 },
      histPushed: false,
      timers: [],
      raf: 0,
      hintShown: false,
    };

    build();
    document.body.classList.add('bs-gal-open');

    // Android tlačítko zpět zavírá galerii (README §Gesta)
    try {
      window.history.pushState({ bsGal: 1 }, '');
      st.histPushed = true;
    } catch (e) { /* file:// fixtures */ }
    window.addEventListener('popstate', onPop);
    document.addEventListener('keydown', onKey, true);

    if (!reducedMotion()) {
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          if (st) st.overlay.classList.add('is-open');
        });
      });
    } else if (st) st.overlay.classList.add('is-open');

    show(st.index, true);
    if (st.close) st.close.focus();
  }

  function closeUi() {
    // zavření z UI: shodit history stav, popstate dokončí úklid
    if (!st) return;
    if (st.histPushed) {
      st.histPushed = false;
      window.history.back();
    } else destroy();
  }

  function onPop() {
    if (!st) return;
    st.histPushed = false;
    destroy();
  }

  function destroy() {
    if (!st) return;
    const s = st;
    st = null;
    s.timers.forEach(clearTimeout);
    if (s.raf) cancelAnimationFrame(s.raf);
    window.removeEventListener('popstate', onPop);
    document.removeEventListener('keydown', onKey, true);
    document.body.classList.remove('bs-gal-open');
    const remove = function () { s.overlay.remove(); };
    if (reducedMotion()) remove();
    else {
      s.overlay.classList.remove('is-open');
      s.overlay.addEventListener('transitionend', remove, { once: true });
      setTimeout(remove, 400); // pojistka, kdyby transitionend nedoběhl
    }
    if (s.opener && s.opener.focus) s.opener.focus();
  }

  function later(fn, ms) {
    if (!st) return 0;
    const id = setTimeout(fn, ms);
    st.timers.push(id);
    return id;
  }

  function show(index, initial) {
    if (!st) return;
    const n = st.photos.length;
    st.index = ((index % n) + n) % n;
    resetZoom();
    if (st.desktop) renderDesktopPhoto();
    else renderMobilePhoto();
    // přednačíst sousedy (README: aktuální ±1)
    [st.index - 1, st.index + 1].forEach(function (i) {
      if (i >= 0 && i < n) new Image().src = st.photos[i].big;
    });
    if (!initial && st.count) st.count.textContent = counterText();
  }

  function counterText() {
    return (st.index + 1) + ' / ' + st.photos.length;
  }

  function resetZoom() {
    if (!st) return;
    st.z = 1;
    st.mz = { z: 1, x: 0, y: 0 };
    if (st.frame) {
      st.frame.style.transform = '';
      st.frame.style.transformOrigin = '';
      st.frame.classList.remove('is-zoomed');
    }
    if (st.mzoomEl) st.mzoomEl.style.transform = '';
    syncMobileZoomUi();
  }

  // ---------------------------------------------------------------------------
  // Stavba UI (desktop / mobil) — při resize přes breakpoint se přestaví,
  // index zůstává, zoom se ruší (README §Integrace)
  // ---------------------------------------------------------------------------

  function build() {
    if (st.overlay) st.overlay.remove();
    const overlay = node('div', 'bs-gal' + (st.desktop ? '' : ' bs-gal--m'));
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-label', LABEL_DIALOG);
    st.overlay = overlay;
    if (st.desktop) buildDesktop(overlay);
    else buildMobile(overlay);
    overlay.addEventListener('keydown', trapFocus);
    document.body.appendChild(overlay);
  }

  function rebuild() {
    if (!st) return;
    const wasOpen = st.overlay && st.overlay.classList.contains('is-open');
    st.desktop = mqDesktop.matches;
    build();
    if (wasOpen) st.overlay.classList.add('is-open');
    show(st.index, true);
  }

  mqDesktop.addEventListener ? mqDesktop.addEventListener('change', rebuild) : mqDesktop.addListener(rebuild);

  // --- desktop ---------------------------------------------------------------

  function buildDesktop(overlay) {
    const stage = node('div', 'bs-gal__stage');
    const frame = node('div', 'bs-gal__frame');
    const img = node('img', 'bs-gal__img');
    img.alt = '';
    frame.appendChild(img);
    stage.appendChild(frame);

    const prev = button('bs-gal__nav bs-gal__nav--prev', LABEL_PREV);
    prev.appendChild(icon('arrow-left'));
    const next = button('bs-gal__nav bs-gal__nav--next', LABEL_NEXT);
    next.appendChild(icon('arrow-right'));
    prev.addEventListener('click', function () { show(st.index - 1); });
    next.addEventListener('click', function () { show(st.index + 1); });
    stage.appendChild(prev);
    stage.appendChild(next);

    const count = node('span', 'bs-gal__count', '');
    count.setAttribute('aria-live', 'polite');
    const caption = node('span', 'bs-gal__caption', '');
    caption.hidden = true;
    stage.appendChild(count);
    stage.appendChild(caption);

    // zoom: klik do fotky, origin sleduje kurzor, kolečko dolaďuje
    frame.addEventListener('click', function (e) {
      if (st.z === 1) {
        st.z = ZOOM_CLICK;
        setOriginFromEvent(e);
        frame.classList.add('is-zoomed');
      } else {
        st.z = 1;
        frame.classList.remove('is-zoomed');
      }
      applyDesktopZoom();
    });
    stage.addEventListener('mousemove', function (e) {
      if (st.z > 1) setOriginFromEvent(e);
    });
    stage.addEventListener('wheel', function (e) {
      if (st.z <= 1) return;
      e.preventDefault();
      st.z = clamp(st.z - e.deltaY * 0.002, 1, ZOOM_MAX);
      if (st.z === 1) frame.classList.remove('is-zoomed');
      applyDesktopZoom();
    }, { passive: false });

    const panel = node('div', 'bs-gal__panel');
    const head = node('div', 'bs-gal__head');
    const titles = node('div', 'bs-gal__titles');
    const crumb = [...document.querySelectorAll('.breadcrumbs a')].filter(function (a) {
      return text(a) && !a.classList.contains('navigation-home-icon');
    }).pop();
    if (crumb) titles.appendChild(node('span', 'bs-gal__eyebrow', text(crumb)));
    titles.appendChild(node('span', 'bs-gal__name', productName()));
    head.appendChild(titles);
    const close = button('bs-gal__close', LABEL_CLOSE);
    close.appendChild(icon('close'));
    close.addEventListener('click', closeUi);
    head.appendChild(close);
    panel.appendChild(head);

    // cena + CTA jen když na stránce žije nákupní form (nedostupný produkt ho nemá)
    const finalEl = form && form.querySelector('.price-final');
    if (finalEl) {
      const priceRow = node('div', 'bs-gal__price');
      // holder = jen částka; celé .price-final nese i „/ ks" (price-measure)
      priceRow.appendChild(node('span', 'bs-gal__price-final', text(form.querySelector('.price-final .price-final-holder') || finalEl)));
      const stdEl = form.querySelector('.price-standard');
      if (text(stdEl)) priceRow.appendChild(node('s', 'bs-gal__price-standard', text(stdEl)));
      const pct = discountPercent(form);
      if (pct) priceRow.appendChild(node('span', 'bs-gal__price-badge', '−' + pct + '\u00A0%'));
      panel.appendChild(priceRow);

      const realBtn = form.querySelector('.add-to-cart-button');
      if (realBtn) {
        const cta = button('bs-gal__cta');
        cta.appendChild(icon('cart'));
        const ctaLabel = node('span', null, LABEL_CART);
        cta.appendChild(ctaLabel);
        cta.addEventListener('click', function () {
          realBtn.click(); // nativní handler formu = jediná cesta do košíku
          closeUi(); // modal „Přidáno do košíku" proběhne nad stránkou
        });
        panel.appendChild(cta);
        st.ctaLabel = ctaLabel;
        st.watchRender = function (state) {
          if (st && st.ctaLabel) st.ctaLabel.textContent = LABEL_CART + ' · ' + (isFinite(state.total) ? formatPrice(state.total, state.currency) : state.text);
        };
        // Odběratel jen jednou za život stránky — subscribe nemá unsubscribe
        // a každé otevření by přidalo další closure (code review 2026-09-09, B2-02).
        // Odběratel čte `st.watchRender` živě, takže obslouží i další otevření.
        if (!watch) {
          watch = createPriceWatch(form);
          watch.subscribe(function (state) {
            if (st && st.watchRender) st.watchRender(state);
          });
        } else {
          st.watchRender(watch.state);
        }
      }
    }

    panel.appendChild(node('div', 'bs-gal__hr'));
    panel.appendChild(node('span', 'bs-gal__all', LABEL_ALL_PHOTOS + ' (' + st.photos.length + ')'));

    const thumbs = node('div', 'bs-gal__thumbs');
    st.photos.forEach(function (p, i) {
      const t = button('bs-gal__thumb', LABEL_PHOTO + ' ' + (i + 1));
      const ti = node('img');
      ti.src = p.thumb;
      ti.alt = '';
      ti.loading = 'lazy';
      t.appendChild(ti);
      t.addEventListener('click', function () { show(i); });
      thumbs.appendChild(t);
    });
    panel.appendChild(thumbs);

    const back = button('bs-gal__back');
    back.appendChild(icon('arrow-left'));
    back.appendChild(node('span', null, LABEL_BACK));
    back.addEventListener('click', closeUi);
    panel.appendChild(back);

    overlay.appendChild(stage);
    overlay.appendChild(panel);

    st.stage = stage;
    st.frame = frame;
    st.img = img;
    st.count = count;
    st.caption = caption;
    st.close = close;
    st.thumbs = thumbs;
    if (watch && st.watchRender) st.watchRender(watch.state);
  }

  function setOriginFromEvent(e) {
    // origin z NEtransformované pozice rámu (getBoundingClientRect po scale
    // vrací zvětšený box a pan by se lepil ke středu) — rám je centrovaný
    // ve stage, layout rozměr drží offsetWidth/Height
    const s = st.stage.getBoundingClientRect();
    const w = st.frame.offsetWidth;
    const h = st.frame.offsetHeight;
    const left = s.left + (s.width - w) / 2;
    const top = s.top + (s.height - h) / 2;
    const x = clamp(((e.clientX - left) / w) * 100, 0, 100);
    const y = clamp(((e.clientY - top) / h) * 100, 0, 100);
    st.frame.style.transformOrigin = x + '% ' + y + '%';
  }

  function applyDesktopZoom() {
    st.frame.style.transform = st.z === 1 ? '' : 'scale(' + st.z + ')';
  }

  function renderDesktopPhoto() {
    const p = st.photos[st.index];
    st.img.src = p.big;
    st.count.textContent = counterText();
    const cap = captionFor(p.caption, productName());
    st.caption.textContent = cap;
    st.caption.hidden = !cap;
    [...st.thumbs.children].forEach(function (t, i) {
      t.classList.toggle('is-active', i === st.index);
    });
  }

  // --- mobil -----------------------------------------------------------------

  function buildMobile(overlay) {
    const top = node('div', 'bs-gal__mtop');
    const count = node('span', 'bs-gal__count', '');
    count.setAttribute('aria-live', 'polite');
    const close = button('bs-gal__close', LABEL_CLOSE);
    close.appendChild(icon('close'));
    close.addEventListener('click', closeUi);
    top.appendChild(node('span', 'bs-gal__mtop-slot'));
    top.appendChild(count);
    top.appendChild(close);

    const stage = node('div', 'bs-gal__mstage');
    const track = node('div', 'bs-gal__mtrack');
    stage.appendChild(track);

    const bottom = node('div', 'bs-gal__mbottom');
    const dots = node('div', 'bs-gal__dots');
    dots.setAttribute('aria-hidden', 'true');
    const strip = node('div', 'bs-gal__mthumbs');
    st.photos.forEach(function (p, i) {
      dots.appendChild(node('span', 'bs-gal__dot'));
      const t = button('bs-gal__mthumb', LABEL_PHOTO + ' ' + (i + 1));
      const ti = node('img');
      ti.src = p.thumb;
      ti.alt = '';
      ti.loading = 'lazy';
      t.appendChild(ti);
      t.addEventListener('click', function () { show(i); });
      strip.appendChild(t);
    });
    bottom.appendChild(dots);
    bottom.appendChild(strip);

    const badge = node('span', 'bs-gal__zoombadge', '');
    badge.hidden = true;
    const minimap = node('div', 'bs-gal__minimap');
    minimap.appendChild(node('div', 'bs-gal__minimap-view'));
    minimap.hidden = true;
    const hint = node('div', 'bs-gal__hint', LABEL_HINT);
    hint.hidden = true;

    overlay.appendChild(top);
    overlay.appendChild(stage);
    overlay.appendChild(bottom);
    overlay.appendChild(badge);
    overlay.appendChild(minimap);
    overlay.appendChild(hint);

    st.count = count;
    st.close = close;
    st.mtop = top;
    st.mstage = stage;
    st.mtrack = track;
    st.mbottom = bottom;
    st.dots = dots;
    st.mthumbs = strip;
    st.badge = badge;
    st.minimap = minimap;
    st.hint = hint;

    bindMobileGestures(stage);
    pokeChrome();
  }

  // chrome (lišty, tečky, miniatury) mizí po 3 s nečinnosti, tap vrací
  function pokeChrome() {
    if (!st || st.desktop) return;
    st.overlay.classList.remove('is-idle');
    if (st.chromeTimer) clearTimeout(st.chromeTimer);
    st.chromeTimer = later(function () {
      if (st && !st.desktop) st.overlay.classList.add('is-idle');
    }, CHROME_HIDE_MS);
  }

  function renderMobilePhoto() {
    // tři slidy: předchozí | aktuální | další — swipe posouvá track
    st.mtrack.innerHTML = '';
    st.mtrack.style.transition = 'none';
    st.mtrack.style.transform = '';
    st.mzoomEl = null;
    [-1, 0, 1].forEach(function (k) {
      const i = st.index + k;
      const slide = node('div', 'bs-gal__mslide');
      slide.style.transform = 'translateX(' + k * 100 + '%)';
      if (i >= 0 && i < st.photos.length) {
        const zoomEl = node('div', 'bs-gal__mzoom');
        const img = node('img', 'bs-gal__img');
        img.src = st.photos[i].big;
        img.alt = '';
        img.draggable = false;
        zoomEl.appendChild(img);
        slide.appendChild(zoomEl);
        if (k === 0) {
          st.mzoomEl = zoomEl;
          st.mimg = img;
        }
      }
      st.mtrack.appendChild(slide);
    });
    st.count.textContent = counterText();
    [...st.dots.children].forEach(function (d, i) {
      d.classList.toggle('is-active', i === st.index);
    });
    [...st.mthumbs.children].forEach(function (t, i) {
      t.classList.toggle('is-active', i === st.index);
      if (i === st.index && t.scrollIntoView) t.scrollIntoView({ block: 'nearest', inline: 'center', behavior: reducedMotion() ? 'auto' : 'smooth' });
    });
    syncMobileZoomUi();
  }

  function mobileBounds(z) {
    const r = st.mstage.getBoundingClientRect();
    const nw = st.mimg && st.mimg.naturalWidth;
    const nh = st.mimg && st.mimg.naturalHeight;
    return panBounds(r.width, r.height, nw, nh, z || st.mz.z);
  }

  function applyMobileZoom() {
    if (!st.mzoomEl) return;
    const m = st.mz;
    st.mzoomEl.style.transform = m.z === 1 && !m.x && !m.y ? '' : 'translate(' + m.x + 'px, ' + m.y + 'px) scale(' + m.z + ')';
    syncMobileZoomUi();
  }

  function syncMobileZoomUi() {
    if (!st || st.desktop || !st.badge) return;
    const z = st.mz.z;
    st.badge.hidden = z <= 1.01;
    if (!st.badge.hidden) st.badge.textContent = zoomLabel(z);
    // minimapa od 2×: bílý rámeček = viditelný výřez fotky
    if (z >= ZOOM_MINIMAP && st.mimg && st.mimg.naturalWidth) {
      st.minimap.hidden = false;
      const view = st.minimap.firstElementChild;
      const b = mobileBounds(z);
      const r = st.mstage.getBoundingClientRect();
      const fit = Math.min(r.width / st.mimg.naturalWidth, r.height / st.mimg.naturalHeight);
      const w = st.mimg.naturalWidth * fit * z;
      const h = st.mimg.naturalHeight * fit * z;
      const visW = clamp(r.width / w, 0, 1);
      const visH = clamp(r.height / h, 0, 1);
      // translate x ∈ [−b.x, b.x] → pozice výřezu 0..(1−visW)
      const px = b.x ? (b.x - clamp(st.mz.x, -b.x, b.x)) / (2 * b.x) : 0.5;
      const py = b.y ? (b.y - clamp(st.mz.y, -b.y, b.y)) / (2 * b.y) : 0.5;
      view.style.width = visW * 100 + '%';
      view.style.height = visH * 100 + '%';
      view.style.left = px * (1 - visW) * 100 + '%';
      view.style.top = py * (1 - visH) * 100 + '%';
      if (st.minimapTimer) clearTimeout(st.minimapTimer);
    } else if (st.minimap) st.minimap.hidden = true;
  }

  function minimapCooldown() {
    if (!st || st.minimap.hidden) return;
    if (st.minimapTimer) clearTimeout(st.minimapTimer);
    st.minimapTimer = later(function () {
      if (st && st.minimap) st.minimap.hidden = true;
    }, MINIMAP_HIDE_MS);
  }

  function showHintOnce() {
    if (!st || st.hintShown) return;
    st.hintShown = true;
    let seen = false;
    try {
      seen = !!sessionStorage.getItem(HINT_KEY);
      sessionStorage.setItem(HINT_KEY, '1');
    } catch (e) { /* private mode */ }
    if (seen) return;
    st.hint.hidden = false;
    later(function () {
      if (st && st.hint) st.hint.hidden = true;
    }, HINT_HIDE_MS);
  }

  // --- mobilní gesta ---------------------------------------------------------

  function bindMobileGestures(stage) {
    const pointers = new Map();
    let g = null; // aktivní gesto: { mode, ... }
    let lastTap = { t: 0, x: 0, y: 0 };

    function stopInertia() {
      if (st && st.raf) {
        cancelAnimationFrame(st.raf);
        st.raf = 0;
      }
    }

    function setTrack(px, anim) {
      st.mtrack.style.transition = anim && !reducedMotion() ? 'transform .3s cubic-bezier(.2,0,0,1)' : 'none';
      st.mtrack.style.transform = px ? 'translateX(' + px + 'px)' : '';
    }

    function setDismiss(dy) {
      const h = st.mstage.getBoundingClientRect().height || 1;
      const p = clamp(dy / h, 0, 1);
      st.mtrack.style.transition = 'none';
      st.mtrack.style.transform = 'translateY(' + dy + 'px) scale(' + (1 - p * 0.15) + ')';
      st.overlay.style.setProperty('--bs-gal-dismiss', String(1 - p));
    }

    function clearDismiss(anim) {
      st.mtrack.style.transition = anim && !reducedMotion() ? 'transform .3s cubic-bezier(.2,0,0,1)' : 'none';
      st.mtrack.style.transform = '';
      st.overlay.style.removeProperty('--bs-gal-dismiss');
    }

    function commitSwipe(dir) {
      // dir +1 = další (track jede doleva)
      const w = st.mstage.getBoundingClientRect().width;
      const target = st.index + dir;
      if (target < 0 || target >= st.photos.length) {
        setTrack(0, true);
        return;
      }
      if (reducedMotion()) {
        show(target);
        return;
      }
      setTrack(-dir * w, true);
      const seq = (st.swipeSeq = (st.swipeSeq || 0) + 1);
      const track = st.mtrack;
      const onEnd = function (e) {
        // transitionend BUBLÁ (zoom dítěte) — reagovat jen na vlastní track
        if (e.target !== track) return;
        track.removeEventListener('transitionend', onEnd);
        if (st && st.swipeSeq === seq) show(target);
      };
      track.addEventListener('transitionend', onEnd);
      later(function () {
        track.removeEventListener('transitionend', onEnd);
        if (st && st.swipeSeq === seq && st.index !== target) show(target);
      }, 400);
    }

    stage.addEventListener('pointerdown', function (e) {
      if (!st || st.desktop) return;
      try {
        stage.setPointerCapture(e.pointerId);
      } catch (err) { /* syntetické eventy harnessu pointerId nemají */ }
      pointers.set(e.pointerId, { x: e.clientX, y: e.clientY });
      stopInertia();
      pokeChrome();
      if (pointers.size === 2) {
        const pts = [...pointers.values()];
        g = {
          mode: 'pinch',
          startDist: Math.hypot(pts[0].x - pts[1].x, pts[0].y - pts[1].y) || 1,
          startZ: st.mz.z,
          startX: st.mz.x,
          startY: st.mz.y,
          startMid: { x: (pts[0].x + pts[1].x) / 2, y: (pts[0].y + pts[1].y) / 2 },
        };
      } else if (pointers.size === 1) {
        g = {
          // vždy začíná jako tap — double-tap musí fungovat i při zoomu,
          // pan/swipe/dismiss se rozhodne až po prvním reálném pohybu
          mode: 'tap',
          x0: e.clientX,
          y0: e.clientY,
          t0: e.timeStamp,
          lastX: e.clientX,
          lastY: e.clientY,
          lastT: e.timeStamp,
          vx: 0,
          vy: 0,
          startX: st.mz.x,
          startY: st.mz.y,
          overX: 0,
          moved: false,
        };
      }
    });

    stage.addEventListener('pointermove', function (e) {
      if (!st || st.desktop || !g || !pointers.has(e.pointerId)) return;
      pointers.set(e.pointerId, { x: e.clientX, y: e.clientY });

      if (g.mode === 'pinch' && pointers.size >= 2) {
        const pts = [...pointers.values()];
        const dist = Math.hypot(pts[0].x - pts[1].x, pts[0].y - pts[1].y) || 1;
        const mid = { x: (pts[0].x + pts[1].x) / 2, y: (pts[0].y + pts[1].y) / 2 };
        let z = g.startZ * (dist / g.startDist);
        // rubber-band pod 1× a nad maximem
        if (z < 1) z = 1 - (1 - z) * 0.4;
        if (z > ZOOM_MAX) z = ZOOM_MAX + (z - ZOOM_MAX) * 0.25;
        const scale = z / g.startZ;
        const r = st.mstage.getBoundingClientRect();
        const cx = r.left + r.width / 2;
        const cy = r.top + r.height / 2;
        // bod pod středem prstů drží pozici: nový translate
        st.mz.z = z;
        st.mz.x = mid.x - cx - (g.startMid.x - cx - g.startX) * scale;
        st.mz.y = mid.y - cy - (g.startMid.y - cy - g.startY) * scale;
        applyMobileZoom();
        if (z > 1.05) showHintOnce();
        return;
      }

      const dx = e.clientX - g.x0;
      const dy = e.clientY - g.y0;
      const dt = Math.max(1, e.timeStamp - g.lastT);
      g.vx = (e.clientX - g.lastX) / dt;
      g.vy = (e.clientY - g.lastY) / dt;

      if (g.mode === 'tap' && (Math.abs(dx) > 8 || Math.abs(dy) > 8)) {
        // rozhodnutí osy: při zoomu pan; jinak vodorovně = swipe, dolů = zavírání
        g.mode = st.mz.z > 1 ? 'pan' : Math.abs(dx) >= Math.abs(dy) ? 'swipe' : dy > 0 ? 'dismiss' : 'swipe-void';
        g.moved = true;
      }

      if (g.mode === 'swipe') {
        let off = dx;
        // rubber-band na krajích galerie
        if ((st.index === 0 && dx > 0) || (st.index === st.photos.length - 1 && dx < 0)) off = dx * 0.35;
        setTrack(off, false);
      } else if (g.mode === 'dismiss') {
        setDismiss(Math.max(0, dy));
      } else if (g.mode === 'pan') {
        const b = mobileBounds();
        let nx = g.startX + dx;
        let ny = g.startY + dy;
        // rubber-band za okrajem fotky + sběr přetahu pro přepnutí
        if (nx > b.x) { g.overX = nx - b.x; nx = b.x + g.overX * 0.3; }
        else if (nx < -b.x) { g.overX = nx + b.x; nx = -b.x + g.overX * 0.3; }
        else g.overX = 0;
        if (ny > b.y) ny = b.y + (ny - b.y) * 0.3;
        else if (ny < -b.y) ny = -b.y + (ny + b.y) * 0.3;
        st.mz.x = nx;
        st.mz.y = ny;
        applyMobileZoom();
      }
      g.lastX = e.clientX;
      g.lastY = e.clientY;
      g.lastT = e.timeStamp;
    });

    function settlePan() {
      // dojezd se setrvačností + dopružení do mezí
      const b = mobileBounds();
      if (reducedMotion()) {
        st.mz.x = clamp(st.mz.x, -b.x, b.x);
        st.mz.y = clamp(st.mz.y, -b.y, b.y);
        applyMobileZoom();
        minimapCooldown();
        return;
      }
      let vx = (g && g.vx) || 0;
      let vy = (g && g.vy) || 0;
      let lastT = performance.now();
      function step(now) {
        if (!st || st.desktop) return;
        const dt = Math.min(40, now - lastT);
        lastT = now;
        const decay = Math.pow(0.94, dt / 16);
        vx *= decay;
        vy *= decay;
        let nx = st.mz.x + vx * dt;
        let ny = st.mz.y + vy * dt;
        // pružina zpět do mezí
        const bb = mobileBounds();
        if (nx > bb.x) { nx = bb.x + (nx - bb.x) * 0.6; vx = 0; }
        if (nx < -bb.x) { nx = -bb.x + (nx + bb.x) * 0.6; vx = 0; }
        if (ny > bb.y) { ny = bb.y + (ny - bb.y) * 0.6; vy = 0; }
        if (ny < -bb.y) { ny = -bb.y + (ny + bb.y) * 0.6; vy = 0; }
        st.mz.x = nx;
        st.mz.y = ny;
        applyMobileZoom();
        const settledX = Math.abs(nx - clamp(nx, -bb.x, bb.x)) < 0.5;
        const settledY = Math.abs(ny - clamp(ny, -bb.y, bb.y)) < 0.5;
        if (Math.abs(vx) > 0.01 || Math.abs(vy) > 0.01 || !settledX || !settledY) {
          st.raf = requestAnimationFrame(step);
        } else {
          st.mz.x = clamp(nx, -bb.x, bb.x);
          st.mz.y = clamp(ny, -bb.y, bb.y);
          applyMobileZoom();
          st.raf = 0;
          minimapCooldown();
        }
      }
      st.raf = requestAnimationFrame(step);
    }

    function animateZoomTo(z, x, y) {
      if (!st.mzoomEl) return;
      if (!reducedMotion()) {
        st.mzoomEl.style.transition = 'transform .3s cubic-bezier(.2,0,0,1)';
        st.mzoomEl.addEventListener('transitionend', function () {
          if (st && st.mzoomEl) st.mzoomEl.style.transition = '';
        }, { once: true });
      }
      st.mz = { z: z, x: x, y: y };
      applyMobileZoom();
      if (z > 1) showHintOnce();
      minimapCooldown();
    }

    stage.addEventListener('pointerup', function (e) {
      if (!st || st.desktop || !pointers.has(e.pointerId)) return;
      pointers.delete(e.pointerId);

      if (g && g.mode === 'pinch') {
        if (pointers.size < 2) {
          const b = mobileBounds();
          if (st.mz.z < 1) animateZoomTo(1, 0, 0);
          else {
            const z = clamp(st.mz.z, 1, ZOOM_MAX);
            st.mz.z = z;
            const bb = mobileBounds(z);
            animateZoomTo(z, clamp(st.mz.x, -bb.x, bb.x), clamp(st.mz.y, -bb.y, bb.y));
          }
          void b;
          g = null;
          pointers.clear();
        }
        return;
      }
      if (!g) return;
      const dx = e.clientX - g.x0;
      const dy = e.clientY - g.y0;
      const dur = e.timeStamp - g.t0;
      const w = st.mstage.getBoundingClientRect().width || 1;
      const h = st.mstage.getBoundingClientRect().height || 1;

      if (g.mode === 'tap' && !g.moved && dur < 350) {
        const isDbl = e.timeStamp - lastTap.t < DBLTAP_MS && Math.hypot(e.clientX - lastTap.x, e.clientY - lastTap.y) < 30;
        lastTap = { t: isDbl ? 0 : e.timeStamp, x: e.clientX, y: e.clientY };
        if (isDbl) {
          if (st.mz.z > 1) animateZoomTo(1, 0, 0);
          else {
            // zoom 2,5× do místa dotyku: bod pod prstem zůstává pod prstem
            const r = st.mstage.getBoundingClientRect();
            const px = e.clientX - (r.left + r.width / 2);
            const py = e.clientY - (r.top + r.height / 2);
            const bb = mobileBounds(ZOOM_DBLTAP);
            animateZoomTo(ZOOM_DBLTAP, clamp(px * (1 - ZOOM_DBLTAP), -bb.x, bb.x), clamp(py * (1 - ZOOM_DBLTAP), -bb.y, bb.y));
          }
        } else pokeChrome();
      } else if (g.mode === 'swipe') {
        const commit = Math.abs(dx) > Math.max(SWIPE_COMMIT_PX, w * SWIPE_COMMIT_RATIO) || Math.abs(g.vx) > FLICK_V;
        if (commit && dx !== 0) commitSwipe(dx < 0 ? 1 : -1);
        else setTrack(0, true);
      } else if (g.mode === 'dismiss') {
        if (dy > h * DISMISS_RATIO || g.vy > FLICK_V) closeUi();
        else clearDismiss(true);
      } else if (g.mode === 'pan') {
        if (Math.abs(g.overX) > EDGE_SWITCH_PX) {
          // dotaženo na okraj fotky a přetaženo dál → vedlejší fotka (reset zoomu v show)
          const dir = g.overX < 0 ? 1 : -1;
          const target = st.index + dir;
          if (target >= 0 && target < st.photos.length) show(target);
          else settlePan();
        } else settlePan();
      } else if (g.mode === 'swipe-void') {
        setTrack(0, true);
      }
      g = null;
    });

    stage.addEventListener('pointercancel', function (e) {
      pointers.delete(e.pointerId);
      if (!st || st.desktop) return;
      if (pointers.size === 0) {
        g = null;
        setTrack(0, false);
        clearDismiss(false);
        const b = mobileBounds();
        st.mz.x = clamp(st.mz.x, -b.x, b.x);
        st.mz.y = clamp(st.mz.y, -b.y, b.y);
        if (st.mz.z < 1) st.mz = { z: 1, x: 0, y: 0 };
        applyMobileZoom();
      }
    });
  }

  // ---------------------------------------------------------------------------
  // Klávesnice + focus trap
  // ---------------------------------------------------------------------------

  function onKey(e) {
    if (!st) return;
    if (e.key === 'Escape') {
      e.preventDefault();
      e.stopPropagation();
      if (st.desktop && st.z > 1) {
        st.z = 1;
        st.frame.classList.remove('is-zoomed');
        applyDesktopZoom();
      } else if (!st.desktop && st.mz.z > 1) {
        st.mz = { z: 1, x: 0, y: 0 };
        applyMobileZoom();
      } else closeUi();
    } else if (e.key === 'ArrowLeft') {
      e.preventDefault();
      show(st.index - 1);
    } else if (e.key === 'ArrowRight') {
      e.preventDefault();
      show(st.index + 1);
    }
  }

  function trapFocus(e) {
    if (e.key !== 'Tab' || !st) return;
    const focusables = [...st.overlay.querySelectorAll('button, a[href], [tabindex]:not([tabindex="-1"])')].filter(function (el) {
      return el.offsetParent !== null || el === document.activeElement;
    });
    if (!focusables.length) return;
    const first = focusables[0];
    const last = focusables[focusables.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  }

  // ---------------------------------------------------------------------------
  // Vstupy: klik na hlavní fotku / nativní `a.cbox-gal` (i programový z „+ N fotek")
  // Capture + stopPropagation = default colorbox se ke kliku nedostane.
  // ---------------------------------------------------------------------------

  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    const wrap = e.target.closest('.p-image-wrapper');
    if (!wrap) return;
    const galLink = e.target.closest('a.cbox-gal');
    const mainLink = e.target.closest('a.p-main-image');
    if (!galLink && !mainLink) return;
    e.preventDefault();
    e.stopPropagation();
    const photos = collectPhotos();
    if (!photos.length) return;
    let index = 0;
    const key = hrefKey((galLink || mainLink).href);
    photos.forEach(function (p, i) {
      if (hrefKey(p.big) === key) index = i;
    });
    open(photos, index, mainLink || galLink);
  }, true);
}
